import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NovaTarefa} from "../../../models/nova-tarefa";
import {ProcessoService} from "../../../services/processo-service";
import {AtendimentoService} from "../../../../cadastro/services/atendimento.service";
import {CadastrosGeraisService} from "../../../../cadastro/services/cadastros-gerais.service";
import {TarefaService} from "../../../services/tarefa-service";
import {ListaProcesso} from "../../../models/lista-processo";
import {ListaAtendimento} from "../../../../cadastro/models/lista-atendimento";
import {TipoTarefa} from "../../../../cadastro/gerais/models/tipo-tarefa";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-nova',
    templateUrl: './nova.component.html',
    styleUrl: './nova.component.css',
    standalone: false
})
export class NovaComponent {
  @Output() atualizarLista = new EventEmitter();
  @Input() telaProcesso = false;
  @Input() processoId?: number | null;
  loading = false;
  modalNova = false;
  tarefa = new NovaTarefa();
  processos = new ListaProcesso();
  atendimentos = new ListaAtendimento();
  tiposTarefa: TipoTarefa[] = [];
  tipoVinculo: string = 'nenhum';

  constructor(private processoService: ProcessoService,
              private atendimentoService: AtendimentoService,
              private tipoTarefaService: CadastrosGeraisService,
              private toastr: ToastrService,
              private tarefaService: TarefaService) {
    this.buscarProcessos();
    this.buscarAtendimentos();
    this.buscarTiposTarefa();
  }

  showModalNova(status?: number){
    this.modalNova = true;
    if (status !== undefined) {
      this.tarefa.status = status;
    }
  }

  fecharModal(){
    this.modalNova = false;
  }

  isFormValido(): boolean {
    return !!(
      this.tarefa.descricao &&
      this.tarefa.tipoTarefaId &&
      (this.tarefa.valor !== null && this.tarefa.valor !== undefined && this.tarefa.valor.toString() !== '') &&
      this.tarefa.dataPrevisaoFinalizacao
    );
  }

  startMetodoAtualizarLista(){
    this.atualizarLista.emit();
  }

  salvar(){
    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        if(this.telaProcesso){
          this.tarefa.processoId = this.processoId ?? null;
        } else {
            if (this.tipoVinculo === 'processo') {
                this.tarefa.atendimentoId = null;
                this.tarefa.processoId = this.tarefa.processoId ?? null;
            } else if (this.tipoVinculo === 'atendimento') {
                this.tarefa.processoId = null;
                this.tarefa.atendimentoId = this.tarefa.atendimentoId ?? null;
            } else {
                this.tarefa.processoId = null;
                this.tarefa.atendimentoId = null;
            }
        }
        this.tarefa.tipoTarefaId = this.tarefa.tipoTarefaId ?? null;
        this.loading = true;
        this.tarefaService.adicionar(this.tarefa).subscribe(
          (response) => {
            this.loading = false;
            if (response.sucesso) {
              this.toastr.success("Tarefa salva com sucesso");
              this.tarefa = new NovaTarefa();
              this.startMetodoAtualizarLista();
            } else {
              this.toastr.error("Erro ao salvar tarefa - " + response.errors[0].mensagem);
            }
            this.modalNova = false;
          },
          (error) => {
            this.loading = false;
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
            this.modalNova = false;
          }
        );
      }
    });
  }

  private buscarTiposTarefa(){
    this.tipoTarefaService.selecionarListaTipoTarefas().subscribe(response => {
      if (response.sucesso) {
        this.tiposTarefa = response.dados;
      }
    });
  }

  private buscarProcessos(){
    this.processoService.selecionarLista().subscribe(response => {
      if (response.sucesso) {
        this.processos = response.dados;
      }
    });
  }

  private buscarAtendimentos(){
    this.atendimentoService.selecionarLista().subscribe(response => {
      if (response.sucesso) {
        this.atendimentos = response.dados;
      }
    });
  }
}
